
import Page from '@/Page.vue';
import { Component, Prop } from 'vue-property-decorator';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';
import { ImplementationStateEnum, MeasureModel, ProcessTypeEnum, TenantUserModel } from '@/libs/Api';
import DashboardCardView from '@/libs/dashboard/components/DashboardCardView.vue';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import IssueSolvingItemSmall from '@/libs/issues-solving/components/IssueSolvingItemSmall.vue';
import { measuresStore } from '@/libs/measures/+state/store';

@Component({
    components: {
        IssueSolvingItemSmall,
        DashboardCardView,
    },
})
export default class DashboardMeasures extends Page {
    @Prop() tenantId!: string;
    protected tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
    protected ProcessTypeEnum: typeof ProcessTypeEnum = ProcessTypeEnum;

    get items(): MeasureModel[] {
        return [...measuresStore.useGetter(CrudGetter.Data, 'DashboardMeasures')] ?? [];
    }

    mounted() {
        this.loadItems();
    }

    loadItems() {
        measuresStore.dispatch(
            CrudAction.GetAll,
            createCrudQueryPayload(
                { field: 'implementUntil', index: 1, order: 'asc' },
                [
                    {
                        field: 'implementationState',
                        op: 'in',
                        comparand: [ImplementationStateEnum.New, ImplementationStateEnum.InProgress],
                    },
                    { field: 'measureImplementationUsers.tenantUserId', op: 'eq', comparand: this.tenantUser.id! },
                ],
                {
                    pageIndex: 1,
                    pageSize: 8,
                },
                false,
                'DashboardMeasures'
            )
        );
    }

    getDescription(item: MeasureModel): string {
        if (!item.implementationDescription) {
            return '';
        }
        if (item.implementationDescription.length > 200) {
            return `${item.implementationDescription.substring(0, 200)}...`;
        }
        return item.implementationDescription;
    }
}
